var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-icon",on:{"click":_vm.goToDashboard}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard\n")])}
var staticRenderFns = []

export { render, staticRenderFns }